import { sanitizeUri } from "micromark-util-sanitize-uri"

/** Preserve app-internal schemes for their custom renderers; sanitize everything else. */
export function transformChatMarkdownUrl(value: string): string {
  try {
    if (value.startsWith("sandbox:") || value.startsWith("cite:")) return value
    return sanitizeUri(value)
  } catch {
    return value
  }
}
